import { privateApis } from "../backend";

type AnalyzeResult = {
  score: number;
}

export type CallDetector = {
  id: string;
  detectorCallId?: string;
  currentCallId?: string;
  currentCallRecipient?: string;
}

export async function getCurrentDetector(): Promise<CallDetector | null> {
  return await privateApis.dial.get('/call-detectors-v1/current')
    .catch(error => {
      if (error?.message === "notFoundError") {
        return null;
      }

      throw error;
    });
}

/**
 * Submits the result of analyzing the audio.
 */
export async function createAnalyzeResult(result: AnalyzeResult, callId?: string) {
  await privateApis.dial.post('/call-detectors-v1/result', result, { callId });
}

/**
 * Uploads the audio which was analyzed.
 */
export async function uploadAnalyzedAudio(data: Blob, callId?: string) {
  const formData = new FormData();
  formData.append('file', data);
  await privateApis.dial.post('/call-detectors-v1/result/recording', formData, { callId });
}